import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { setOrders, fetchShopifyOrderStatus, fetchWonderlandPoints } from '../../../redux/actions/orders';
import { createProductImageUrl } from '../../utils/productImageUrl';
import { hasLangParam } from '../../utils/urlLang';
import Language from '../Language.jsx';
import OrdersChrome from '../../components/ordersLayout/OrdersChrome.jsx';
import OnlineOfflineTabs from '../../components/ordersLayout/OnlineOfflineTabs.jsx';
import OrderCardOnline from '../../components/ordersLayout/OrderCardOnline.jsx';
import OrderCardOffline from '../../components/ordersLayout/OrderCardOffline.jsx';
import OfflineOrderDetail from '../../components/ordersLayout/OfflineOrderDetail.jsx';

export class OrdersAppRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      groupedOrders: [],
      activeTab: hasLangParam() ? 'offline' : 'online',
      view: 'list',
      selectedOfflineOrder: null,
      wonderlandPoints: null,
    };
  }

  componentDidMount() {
    const crmId = this.props.login.CrmId;
    this.props.dispatch(setOrders({ crm_id: crmId }));
    if (crmId) {
      this.props.dispatch(fetchWonderlandPoints({ crm_id: crmId })).then((data) => {
        if (data && data.success && data.balance != null) {
          this.setState({ wonderlandPoints: data.balance });
        }
      });
    }

    setTimeout(() => {
      const boarderStyleElement = document.querySelector('.boarderStyle');
      if (boarderStyleElement) {
        boarderStyleElement.addEventListener(
          'touchmove',
          function (e) {
            e.preventDefault();
          },
          { passive: false }
        );
      }
      const scrollRoot = document.querySelector('.orders-layout-app');
      if (scrollRoot) {
        scrollRoot.addEventListener(
          'touchmove',
          function (e) {
            e.stopPropagation();
          },
          { passive: false }
        );
      }
    }, 500);
  }

  async componentDidUpdate(prevProps) {
    const prevItems = prevProps.orders && prevProps.orders.items;
    const nextItems = this.props.orders && this.props.orders.items;
    if (nextItems === prevItems) return;

    if (nextItems && nextItems.length > 0) {
      const groupedOrders = await this.groupByOrderId(nextItems.slice());
      this.setState({ orders: nextItems, groupedOrders });
    } else if (prevItems && prevItems.length > 0) {
      this.setState({ orders: [], groupedOrders: [] });
    }
  }

  formatShipmentStatus = (status) => {
    if (!status || status === 'noData') return status;
    return status
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  async groupByOrderId(orders) {
    if (!orders || orders.length === 0) {
      return [];
    }

    let groupedOrders = [];

    orders.forEach((order) => {
      if (!order.order_id) {
        return;
      }
      // eslint-disable-next-line
      const foundObject = groupedOrders.find((object, index) => {
        if (object.order_id === order.order_id) {
          order.picture_url = createProductImageUrl(order);
          groupedOrders[index].product_list.push(order);
          return true;
        }
        return false;
      });

      if (!foundObject) {
        order.picture_url = createProductImageUrl(order);
        groupedOrders.push({
          order_id: order.order_id,
          purchase_place: '',
          shop_name: '',
          thk_address: '',
          purchase_date: '',
          order_grand_total: '',
          product_price_currency: '',
          product_list: [order],
          is_shopify: 0,
        });
      }
    });

    groupedOrders.forEach((item) => {
      item.product_list.forEach((pItem) => {
        if (pItem.is_shopify === 1) {
          item.is_shopify = 1;
          item.order_id_origin = pItem.order_id_origin;
        }
        if (!item.purchase_place) item.purchase_place = pItem.purchase_place;
        if (!item.shop_name) item.shop_name = pItem.shop_name;
        if (!item.thk_address) item.thk_address = pItem.thk_address;
        if (!item.purchase_date) item.purchase_date = pItem.purchase_date;
        if (!item.order_grand_total) item.order_grand_total = pItem.order_grand_total;
        if (!item.product_price_currency) item.product_price_currency = pItem.product_price_currency;
      });
    });

    const order_ids = groupedOrders.filter((item) => item.is_shopify === 1).map((item) => item.order_id_origin);

    if (!hasLangParam() && order_ids.length > 0) {
      const res = await this.props.dispatch(fetchShopifyOrderStatus(order_ids));
      if (res && res.code === 0) {
        res.data.forEach((status) => {
          const matchingOrder = groupedOrders.find((order) => {
            const orderIdOrigin = order.order_id_origin && order.order_id_origin.toLowerCase();
            const statusOrderNumber = status.order_number && status.order_number.toLowerCase();
            return orderIdOrigin === statusOrderNumber;
          });
          if (matchingOrder) {
            matchingOrder.shipment_status = status.shipment_status
              ? this.formatShipmentStatus(status.shipment_status)
              : 'noData';
          }
        });
      }
    }

    groupedOrders.forEach((groupedOrder) => {
      if (groupedOrder.is_shopify === 0) {
        groupedOrder.shipment_status = 'noData';
      }
    });

    return groupedOrders;
  }

  isOnlineOrder = (g) => g.product_list.some((p) => p.isOnline);

  setTab = (activeTab) => this.setState({ activeTab });

  openOfflineDetail = (selectedOfflineOrder) => {
    this.setState({ view: 'offlineDetail', selectedOfflineOrder });
  };

  backToList = () => {
    this.setState({ view: 'list', selectedOfflineOrder: null });
  };

  render() {
    const { t, dispatch } = this.props;
    const { groupedOrders, activeTab, view, selectedOfflineOrder } = this.state;
    const langEmbedMode = hasLangParam();
    const onlineList = groupedOrders.filter((g) => this.isOnlineOrder(g));
    const offlineList = groupedOrders.filter((g) => !this.isOnlineOrder(g));
    const activeList = langEmbedMode || activeTab === 'offline' ? offlineList : onlineList;

    if (view === 'offlineDetail' && selectedOfflineOrder) {
      return (
        <OrdersChrome>
          <div className="orders-layout-inner orders-layout-inner--offline-detail">
            <OfflineOrderDetail groupedOrder={selectedOfflineOrder} onBack={this.backToList} />
          </div>
        </OrdersChrome>
      );
    }

    return (
      <OrdersChrome>
        <div className={'orders-layout-inner' + (langEmbedMode ? ' orders-layout-inner--lang-embed' : '')}>
          {!langEmbedMode && (
            <div className="orders-page-heading-row">
              <h1 className="orders-page-title">{t('ordersLayout.pageTitleOrders')}</h1>
              <div className="orders-page-heading-row__aside">
                <Language />
              </div>
            </div>
          )}
          {!langEmbedMode && <OnlineOfflineTabs active={activeTab} onChange={this.setTab} t={t} />}
          <div className="orders-card-list">
            {activeList.length === 0 ? (
              <div className="orders-empty">{t('ordersLayout.emptyOrders')}</div>
            ) : langEmbedMode || activeTab === 'offline' ? (
              activeList.map((row) => (
                <OrderCardOffline key={row.order_id} data={row} onViewDetails={this.openOfflineDetail} />
              ))
            ) : (
              activeList.map((row) => (
                <OrderCardOnline key={row.order_id} data={row} dispatch={dispatch} />
              ))
            )}
          </div>
        </div>
      </OrdersChrome>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.orders,
  login: state.login,
});

export default connect(mapStateToProps)(withTranslation()(OrdersAppRoot));



// WEBPACK FOOTER //
// ./src/js/containers/ordersLayout/OrdersAppRoot.jsx